import { StockStatus } from "@/helpers/constants";

export default class StockStatusHelper {
	public static getEffectiveStatus(
		stockStatus: StockStatus | null,
		stockStatusOverride: StockStatus | null
	): StockStatus | null {
		if (stockStatusOverride != null) {
			return stockStatusOverride;
		}

		return stockStatus;
	}

	public static toAlertType(value: StockStatus | null): string {
		switch (value) {
			case StockStatus.stockHigh:
				return "success";
			case StockStatus.stockMedium:
				return "warning";
			case StockStatus.stockLow:
				return "warning";
			case StockStatus.stockNone:
				return "error";
			default:
				return "info";
		}
	}

	public static toAlertTypeWithOverride(
		stockStatus: StockStatus | null,
		stockStatusOverride: StockStatus | null
	): string {
		return this.toAlertType(
			this.getEffectiveStatus(stockStatus, stockStatusOverride)
		);
	}
}